import { RowTypes } from '../../enums/pdf-tron/row-types.enum';

export interface IEquityMovementScheduleFinancialTableData {
    rowType: RowTypes;
    t: string;
    [key: string]: string | number | null;
}
